
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as about6Vgf2e_45ZWwa_45DDxcsm2LFgKBFkBxwt_su_XdCkSeybIMeta } from "/opt/buildhome/repo/pages/about.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as trigger_45errorhcFgZ7Y0l9OlSKCUpO_z_45MdaYyG82tr4_45InfPRYuI3gMeta } from "/opt/buildhome/repo/pages/trigger-error.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    meta: about6Vgf2e_45ZWwa_45DDxcsm2LFgKBFkBxwt_su_XdCkSeybIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta || {}), ...{"middleware":["middleware-1"]} },
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "trigger-error",
    path: "/trigger-error",
    component: () => import("/opt/buildhome/repo/pages/trigger-error.vue")
  }
]